import { type EventSubscription, requireNativeModule } from 'expo-modules-core';
import { Platform } from 'react-native';

const ExpoApplePay = Platform.select({
  ios: () => requireNativeModule('ExpoApplePayModule'),
})?.();

export default ExpoApplePay;

export type { EventSubscription };
